import type { ControlListItem } from "@/models/control.model";
import { HARD_LIMITS } from "@spz/config";
import { Button } from "@spz/ui/components/button";
import { Checkbox } from "@spz/ui/components/checkbox";
import { InlineSpinner } from "@spz/ui/components/inline-spinner";
import { Typography } from "@spz/ui/components/typography";
import type { Table } from "@tanstack/react-table";
import { useExportExcelPopoverViewModel } from "../view-models/use-export-excel-popover.viewmodel";

type ExportExcelPopoverContentProps = {
  analysisId: string;
  table: Table<ControlListItem>;
  onClose: () => void;
  enableDataSourceOption?: boolean;
};

export const ExportExcelPopoverContent = ({
  analysisId,
  table,
  onClose,
  enableDataSourceOption = false,
}: ExportExcelPopoverContentProps) => {
  const { t, exportStatus, handleGenerate, handleCancel, controlsSize } =
    useExportExcelPopoverViewModel({
      analysisId,
      table,
      enableDataSourceOption,
      onClose,
    });

  return (
    <div className="flex flex-col gap-3 w-full">
      {exportStatus === "idle" && (
        <>
          <Typography
            trans="export_excel_description"
            transParams={{ size: controlsSize }}
            className="text-gray-700"
          />
          {enableDataSourceOption && (
            <Checkbox
              label={t("export_excel_checkbox_source_ref")}
              className="justify-start"
            />
          )}
          <Button onClick={handleGenerate}>{t("generate_file")}</Button>
        </>
      )}

      {exportStatus === "validating" && (
        <>
          <Typography
            className="text-gray-700 font-poppins"
            trans="export_excel_validating"
          />
          <InlineSpinner size="medium" className="mx-auto" />

          <Button onClick={handleCancel} variant="secondary">
            {t("cancel_file_request")}
          </Button>
        </>
      )}

      {exportStatus === "error" && (
        <>
          <Typography
            trans="export_excel_error_limit_exceeded"
            transParams={{
              limit:
                HARD_LIMITS.reports.controlResultSelectLimit.toLocaleString(),
            }}
          />
          <Button onClick={handleCancel} variant="secondary">
            {t("close")}
          </Button>
        </>
      )}
    </div>
  );
};
